/* global swal:false*/
(function() {
  'use strict';

  angular
    .module('signup', ['singup.service'])
    .controller('SignupCtrl', SignupCtrl);

  /** @ngInject */
  function SignupCtrl($rootScope, $state, SignupService, UserCache) {
    var vm = this;
    vm.model = {};

    $rootScope.page = 'login';

    UserCache.remove();

    vm.signup = function(){
       SignupService.signup(vm.model).then(function(){
          swal("You account is created !", "But you do not have permission", "warning");
          $state.go('signin');
      });
    };
  }

})();
